/**
 * react-select drawn like the shared UI kit's inputs: flat, a thin border,
 * no shadow, the theme's neutral colours. The menu keeps a faint shadow only
 * so it reads as floating over the form.
 */
const border = 'hsl(var(--border))';
const ink = 'hsl(var(--foreground))';
const muted = 'hsl(var(--muted))';

export const flatSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: 6,
    borderColor: state.isFocused ? ink : border,
    boxShadow: 'none',
    backgroundColor: state.isDisabled ? muted : '#fff',
    fontSize: 14,
    '&:hover': {borderColor: state.isFocused ? ink : 'hsl(var(--muted-foreground))'},
  }),
  valueContainer: base => ({...base, padding: '0 10px'}),
  placeholder: base => ({...base, color: 'hsl(var(--muted-foreground))'}),
  singleValue: base => ({...base, color: ink}),
  indicatorSeparator: () => ({display: 'none'}),
  dropdownIndicator: base => ({...base, color: 'hsl(var(--muted-foreground))', padding: '0 10px'}),
  clearIndicator: base => ({...base, padding: '0 4px'}),
  menu: base => ({
    ...base,
    borderRadius: 8,
    border: `1px solid ${border}`,
    boxShadow: '0 6px 16px rgba(15, 23, 42, 0.06)',
    overflow: 'hidden',
    zIndex: 30,
  }),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    color: ink,
    backgroundColor: state.isSelected ? muted : state.isFocused ? 'hsl(var(--muted) / 0.6)' : '#fff',
    '&:active': {backgroundColor: muted},
  }),
  multiValue: base => ({...base, backgroundColor: muted, borderRadius: 4}),
  multiValueLabel: base => ({...base, color: ink, fontSize: 13}),
};
